(function () {
  'use strict';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-ahq-video-toggle]').forEach(button => {
    const section = button.closest('.m-hero');
    const video = section && section.querySelector('video');
    if (!video) return;
    button.hidden = false;
    let userRequestedPlayback = false;
    const update = () => { button.textContent = video.paused ? 'Play background video' : 'Pause background video'; };
    video.addEventListener('play', () => {
      if (reducedMotion.matches && !userRequestedPlayback) video.pause();
      update();
    });
    video.addEventListener('pause', update);
    button.addEventListener('click', () => {
      if (video.paused) {
        userRequestedPlayback = true;
        video.play().catch(update);
      } else { userRequestedPlayback = false; video.pause(); }
    });
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) { userRequestedPlayback = false; video.pause(); }
    });
    if (reducedMotion.matches) video.pause();
    update();
  });

  // Instafeed inserts these focusable links after the theme has rendered.
  // Supply names from the actual post links, without changing app behavior.
  const feed = document.getElementById('insta-feed');
  if (feed) {
    const labelPosts = () => {
      feed.querySelectorAll('[role="link"]:not([aria-label])').forEach((post, index) => {
        const link = post.querySelector('a[href]');
        const image = post.querySelector('img[alt]');
        const description = image && image.alt.trim();
        post.setAttribute('aria-label', description || (link && link.getAttribute('aria-label')) || `Open Instagram post ${index + 1}`);
      });
    };
    labelPosts();
    new MutationObserver(labelPosts).observe(feed, { childList: true, subtree: true });
  }
})();
